import { useState, useCallback } from "react";

export function useFileExplorerModals() {
  const [isFiltersOpen, setIsFiltersOpen] = useState(false);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);

  const toggleFilters = useCallback(
    () => setIsFiltersOpen((prev) => !prev),
    []
  );
  const openUpload = useCallback(() => setIsUploadModalOpen(true), []);
  const closeUpload = useCallback(() => setIsUploadModalOpen(false), []);

  return {
    isFiltersOpen,
    isUploadModalOpen,
    toggleFilters,
    openUpload,
    closeUpload,
    setIsFiltersOpen,
    setIsUploadModalOpen,
  };
}

